var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.$store.state.renderComponentTicket)?_c('TickCp',{attrs:{"PropsCustomer":_vm.PropsCustomer,"FromCustomer":_vm.FromCustomer}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }